export default function isBoolean(value) {
    return value === true || value === false;
}
